export default __webpack_public_path__ + "static/media/22.485be133.png";